import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL
export const EXTERNAL_URL = process.env.VUE_APP_EXTERNAL_URL

export const loadErrorPage = () => {
  document.location.href = `${EXTERNAL_URL}404`
}

export const pingLead = async (leadUID) => {
  return await axios
    .get(`${API_URL}/v1/pingLead/${leadUID}`)
    .then(({ data }) => ({ success: true, status: data.status }))
    .catch(error => ({ success: false, error }))
}

export const getLead = async (leadUID) => {
  return await axios
    .get(`${API_URL}/v1/getLead/${leadUID}`)
    .then(({ data: { lead } }) => ({ success: true, lead }))
    .catch(error => ({ sucess: false, error }))
}

export const processLead = async (leadUID, data, token) => {
  return await axios
    .post(`${API_URL}/v1/processLead/${leadUID}`, data, {
      headers: { Authorization: token }
    })
    .then(data => {
      return { success: true, isFinished: data.status === 200 }
    })
    .catch(error => ({ success: false, error }))
}

export const createLead = async (data, token) => {
  return await axios
    .post(`${API_URL}/v1/createLead/`, data, {
      headers: { Authorization: token }
    })
    .then(({ data: { uid } }) => ({ success: true, uid }))
    .catch(error => ({ success: false, error }))
}

export const resendLink = async (data, token) => {
  return await axios
    .post(`${API_URL}/v1/resendLink/`, data, {
      headers: { Authorization: token }
    })
    .then(() => ({ success: true }))
    .catch(error => ({ success: false, error }))
}

export const sepomex = async (cp) => {
  return await axios
    .get(`${API_URL}/v1/sepomex/${cp}`)
    .then(({ data }) => ({ success: true, data }))
    .catch(error => ({ success: false, error }))
}

export const getToken = async (tracking) => {
  return await axios
    .get(`${API_URL}/v1/auth/getToken/?${tracking}`)
    .then(({ data }) => ({ success: true, data }))
    .catch(error => ({ success: false, error }))
}

export const getProductos = async () => {
  return await axios
    .get(`${API_URL}/v1/products`)
    .then(({ data }) => ({ success: true, data }))
    .catch(error => ({ success: false, error }))
}

export const getPlazos = async () => {
  return await axios
    .get(`${API_URL}/v1/terms`)
    .then(({ data }) => ({ success: true, data }))
    .catch(error => ({ success: false, error }))
}

export const getTasas = async () => {
  return await axios
    .get(`${API_URL}/v1/rates/`)
    .then(({ data }) => ({ success: true, data }))
    .catch(error => ({ success: false, error }))
}

export const getTasaByPlazo = async (plazo, producto) => {
  return await axios
    .get(`${API_URL}/v1/rateByTerm/${plazo}/${producto}`)
    .then(({ data }) => ({ success: true, data }))
    .catch(error => ({ success: false, error }))
}

export const getTestimonios = async () => {
  return await axios
    .get(`${API_URL}/v1/testimonials`)
    .then(({ data }) => ({ success: true, data }))
    .catch(error => ({ success: false, error }))
}

export default {
  install () {}
}
